import React, {useEffect, useState} from 'react'

import _ from 'lodash'
import './contrato-falecido-epi.scss'
import {Card} from 'primereact/card'
import {Checkbox} from "primereact/checkbox";
import {InputText} from "primereact/inputtext";
import {PickList} from "primereact/picklist";
import {Tooltip} from "primereact/tooltip";
import utils from '../../../utils'

export default function ContratoFalecidoAdiau(props) {
  const [camerasAdiauDisponiveis, setCamerasAdiauDisponiveis] = useState(props.camerasAdiauDisponiveis || [])

  // A lista chega da Adiaŭ depois da montagem e o pai devolve um array novo a cada render, por isso
  // a sincronia observa os ids e não a referência.
  const idsCamerasDisponiveis = (props.camerasAdiauDisponiveis || []).map((camera) => camera.id).join(',')
  useEffect(() => {
    setCamerasAdiauDisponiveis(props.camerasAdiauDisponiveis || [])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idsCamerasDisponiveis])

  const setField = (field, value) => {
    const integracaoAdiau = _.get(props, 'integracaoAdiau', {}) || {}
    integracaoAdiau[field] = value
    props.setField('integracaoAdiau', integracaoAdiau)
  }

  const onChangeCamerasAdiau = e => {
    setCamerasAdiauDisponiveis(e.source)

    let cameras = _.get(props, 'cameras', [])
    cameras = e.target
    setField('cameras', cameras)
  };

  // Sem a chave no dicionário o aviso não é exibido, mesmo padrão dos textos de ajuda.
  const avisoCamerasIndisponiveis = utils.getMessage(props.messages, 'contrato.label.adiau.camerasIndisponiveis')

  const ajuda = (campo) => {
    const texto = utils.getMessage(props.messages, `contrato.label.tooltip.adiau.${campo}`)
    if (!texto) {
      return null
    }
    return (
      <i
        className="pi pi-question-circle tooltip-adiau"
        style={{marginLeft: '5px', cursor: 'help'}}
        data-pr-tooltip={texto}
        data-pr-position="top"
      />
    )
  }

  return (
    <React.Fragment>
      <Card>
        <Tooltip target=".tooltip-adiau" style={{maxWidth: '350px'}}/>
        <div className="p-grid form-group">

          {_.get(props.integracaoAdiau, 'idTransmissao', null) ? (
            <div className="p-col-12 p-sm-12 p-md-6 p-lg-6 p-xl-6">
              <span className="p-text-bold">Transmissão criada, código: {_.get(props.integracaoAdiau, 'idTransmissao', null)}</span>
            </div>
          ) : null}

          <div className="p-col-12">
            <Checkbox
              inputId="chkAtivar"
              name="chkAtivar"
              checked={_.get(props.integracaoAdiau, 'habilitado', false)}
              onChange={(e) => setField('habilitado', e.checked)}>
            </Checkbox>
            <label style={{marginLeft: '5px'}}
                   htmlFor="chkAtivar">Habilitar
            </label>
            {ajuda('habilitar')}
          </div>
          <div className="p-col-12">

            <Checkbox
              inputId="chkEventoPublico"
              name="chkEventoPublico"
              checked={_.get(props.integracaoAdiau, 'eventoPublico', false)}
              onChange={(e) => setField('eventoPublico', e.checked)}
              disabled={!_.get(props.integracaoAdiau, 'habilitado', false)}>
            </Checkbox>
            <label style={{marginLeft: '5px'}}
                   htmlFor="chkEventoPublico">Evento público
            </label>
            {ajuda('eventoPublico')}
          </div>
          <div className="p-col-12">

            <Checkbox
              inputId="chkAudio"
              name="chkAudio"
              checked={_.get(props.integracaoAdiau, 'audio', true)}
              onChange={(e) => setField('audio', e.checked)}
              disabled={!_.get(props.integracaoAdiau, 'habilitado', false)}>
            </Checkbox>
            <label style={{marginLeft: '5px'}}
                   htmlFor="chkAudio">Áudio
            </label>
            {ajuda('audio')}
          </div>
          <div className="p-col-12">

            <Checkbox
              inputId="chkModeracaoMensagens"
              name="chkModeracaoMensagens"
              checked={_.get(props.integracaoAdiau, 'moderacaoMensagens', false)}
              onChange={(e) => setField('moderacaoMensagens', e.checked)}
              disabled={!_.get(props.integracaoAdiau, 'habilitado', false)}>
            </Checkbox>
            <label style={{marginLeft: '5px'}}
                   htmlFor="chkModeracaoMensagens">Moderar mensagens
            </label>
            {ajuda('moderacaoMensagens')}
          </div>
          <div className="p-col-12" style={{display: 'flex', alignItems: 'center'}}>

            <span className="p-float-label">
              {/* name/id sem "password" e autoComplete desligado: o gerenciador de senhas do
                  navegador preenchia o campo sozinho com a senha salva do usuário. */}
              <InputText
                value={_.get(props.integracaoAdiau, 'senha', '') || ''}
                onChange={(e) => setField('senha', e.target.value)}
                name="senhaAdiau"
                id="senhaAdiau"
                autoComplete="off"
                disabled={!_.get(props.integracaoAdiau, 'habilitado', false)}
              />
              <label htmlFor="senhaAdiau">Senha</label>
            </span>
            {ajuda('senha')}
          </div>

          <div className="p-col-12">

            <label style={{marginLeft: '10px'}}
                   htmlFor="listCameras">Câmeras
            </label>
            {ajuda('cameras')}
            {props.camerasAdiauIndisponiveis && avisoCamerasIndisponiveis ? (
              <div style={{margin: '5px 0 5px 10px', color: '#8a6d3b', fontSize: '0.85em'}}>
                <i className="pi pi-exclamation-triangle" style={{marginRight: '5px'}}/>
                {avisoCamerasIndisponiveis}
              </div>
            ) : null}
            <PickList
              id="listCameras"
              name="listCameras"
              responsive={true}
              source={camerasAdiauDisponiveis}
              target={_.get(props.integracaoAdiau, 'cameras', [])}
              onChange={e => onChangeCamerasAdiau(e)}
              itemTemplate={(camera) => (
                <label>
                  {camera.id} - {_.get(camera, 'name') || _.get(camera, 'title')}
                  {_.get(camera, 'description') && _.get(camera, 'description') !== _.get(camera, 'name')
                    ? ` (${_.get(camera, 'description')})`
                    : ''}
                </label>
              )}
              sourceHeader="Disponíveis"
              targetHeader="Selecionados"
              showSourceControls={false}
              showTargetControls={false}
              showSourceFilter={false}
              showTargetFilter={false}
              dataKey="id"

            />
          </div>
        </div>
      </Card>
    </React.Fragment>
  )
}
